import { IPayloadAction } from '../scanner/scanner.actions';
import { IDiagnosticPayload, IDocumentResult, IGetDiagnosticPayload } from '../interfaces';

export const ResultsActions = {
  UPDATE_RESULTS_STATUS: '[Results] Get Update Results for the current session',
  GET_RESULTS: '[Results] Get by requested sessionId',
  SET_RESULTS_DATA: '[Results] Set Results Data',
  RESULTS_ERROR: '[Results] Results Error',
  EXPIRE_PROCESSING_RESULTS: '[Results] Expire Processing Results for the current session',
  GET_DIAGNOSTIC_RESULTS: '[Results] Get Diagnostic Results',
  DIAGNOSTIC_RESULTS_RECEIVED: '[Results] Diagnostic Results Received',
};

export const CURRENT_SESSION_KEY = 'current';

export class UpdateResultsStatus implements IPayloadAction {
  readonly type = ResultsActions.UPDATE_RESULTS_STATUS;
}

export class GetDiagnosticResults implements IPayloadAction {
  readonly type = ResultsActions.GET_DIAGNOSTIC_RESULTS;
  constructor(public payload: IGetDiagnosticPayload) {}
}

export class ExpireProcessingResults implements IPayloadAction {
  readonly type = ResultsActions.EXPIRE_PROCESSING_RESULTS;
}

export class ResultsDataReceived implements IPayloadAction {
  readonly type = ResultsActions.SET_RESULTS_DATA;
  constructor(public payload: IDocumentResult[]) {}
}

export class DiagnosticResultsReceived implements IPayloadAction {
  readonly type = ResultsActions.DIAGNOSTIC_RESULTS_RECEIVED;
  constructor(public payload: IDiagnosticPayload) {}
}

export class ResultsDataError implements IPayloadAction {
  readonly type = ResultsActions.RESULTS_ERROR;
  constructor(public payload) {}
}
